import React from 'react';
import { Loader } from './Loader';
import { Stack } from './Stack';
export function FullScreenLoader(props) {
    return (React.createElement(Stack, { align: "center", justify: "center", className: "h-screen", width: "full" },
        React.createElement(Loader, Object.assign({}, props))));
}
